import React from 'react';

/* Static module card — uniform header + body, no drag, no resize.
   `titleInfo` renders an optional node (e.g. an info tooltip) right of the label. */
function StaticCard({ id, label, accent, titleInfo, children, style, className = '' }) {
  return (
    <div
      className={`drm-final-card ${className}`}
      data-density="md"
      data-module-id={id}
      style={style}
    >
      {label && (
        <div className="drm-final-card-head">
          {accent && <span className="drm-final-card-dot" style={{ background: accent }} />}
          <span className="drm-final-card-label">{label}</span>
          {titleInfo}
        </div>
      )}
      <div className="drm-module--body">{children}</div>
    </div>
  );
}

export default StaticCard;
